import { render, staticRenderFns } from "./root-user.vue?vue&type=template&id=216d7af3&scoped=true&"
import script from "./root-user.vue?vue&type=script&lang=js&"
export * from "./root-user.vue?vue&type=script&lang=js&"
import style0 from "./root-user.vue?vue&type=style&index=0&id=216d7af3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216d7af3",
  null
  
)

export default component.exports